import React from 'react';

import '../Tutorial.css';
import Typewriter from "typewriter-effect";
import TutorialGirl from "../TutorialGirl";

function T200ArenaStart() {

    const text = 'Tap the Arena icon in the main menu and start earning Gems in the PvP Arena.';

    return <div>

        <div className={'T200Left'}></div>
        <div className={'T200Right'}></div>
        <div className={'T150Bottom'}></div>

        <TutorialGirl undressingProcess={3}/>
        <div className='tutorialContainer tutorialTopContainer95'>
            <div className='tutorialBottomTextField'><Typewriter
                options={{
                    delay: 30
                }}
                onInit={(typewriter) => {
                    typewriter.typeString(text).start();
                }}
            /></div>
        </div>
    </div>
}

export default T200ArenaStart;